module.exports = __webpack_public_path__ + "img/Jump Casting132.607ed5f9.jpg";